(() => {
  angular
    .module('app.components')
    .directive('customSegments', ['$sce', function($sce) {
      return {
        restrict: "E",
        templateUrl: $sce.trustAsResourceUrl('/assets/js/app/components/customSegments/customSegments.html?v=${window.BUILD_VERSION}'),
        transclude: true,
        scope: {
          manage: "@",
          invert: "@",
          campaignId: "="
        },
        controller: 'CustomSegmentsController',
        controllerAs: 'customSegments'
      };
    }]);
})();
